import * as React from 'react';
import WysiwygField from '../WysiwygField';

import './style.scss';

type Props = {
  html: string;
};

const BodyField: React.FC<Props> = (props) => {
  const { html } = props;

  return (
    <div className="BodyField">
      <WysiwygField
        html={html}
      />
    </div>
  );
};

export default BodyField;
